import { render, staticRenderFns } from "./dashboardgk.vue?vue&type=template&id=722e809a&scoped=true"
import script from "./dashboardgk.vue?vue&type=script&lang=js"
export * from "./dashboardgk.vue?vue&type=script&lang=js"
import style0 from "./dashboardgk.vue?vue&type=style&index=0&id=722e809a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e809a",
  null
  
)

export default component.exports